import { ImageUp, Trash2 } from 'lucide-react';
import { Button } from '@/shared/components';
import type { PropertyPortalBrandingResponse } from '@/shared/api';
import { formatLogoMetadata } from './portalBrandingFormat';

/** Das Logo der Marke: ein neues gilt sofort, ohne „Branding speichern“. */
export function PortalLogoField({
  branding,
  editable,
  busy,
  onUpload,
  onRemove,
}: {
  branding: PropertyPortalBrandingResponse;
  editable: boolean;
  busy: boolean;
  onUpload: (file: File) => void;
  onRemove: () => void;
}) {
  const metadata = formatLogoMetadata(branding);
  return (
    <div className="border-line/60 border-t pt-5">
      <p className="text-ink text-sm font-semibold">Logo</p>
      <p className="text-ink mt-1 text-sm">{metadata ?? 'Noch kein eigenes Logo'}</p>
      {editable && (
        <div className="mt-3 flex flex-wrap gap-2">
          <label className="border-line bg-paper text-ink flex min-h-11 cursor-pointer items-center gap-2 rounded-md border px-3 text-sm font-semibold">
            <ImageUp className="size-4" aria-hidden />
            {branding.hasLogo ? 'Logo ersetzen' : 'Logo auswählen'}
            <input
              className="sr-only"
              aria-label="Portal-Logo hochladen"
              type="file"
              accept="image/png,image/jpeg"
              disabled={busy}
              onChange={(event) => {
                const file = event.target.files?.[0];
                if (file) onUpload(file);
                event.target.value = '';
              }}
            />
          </label>
          {branding.hasLogo && (
            <Button
              type="button"
              variant="destructive"
              className="min-h-11"
              leftIcon={<Trash2 className="size-4" />}
              disabled={busy}
              onClick={onRemove}
            >
              Logo entfernen
            </Button>
          )}
        </div>
      )}
      <p className="text-ink-soft mt-2 text-xs">
        PNG oder JPEG. Transparenz bleibt erhalten; große Bilder werden einmal verkleinert. Ein
        neues Logo gilt sofort.
      </p>
    </div>
  );
}
